import { useTranslation } from "react-i18next";
import { CloseOutlined, FileExcelOutlined, LoadingOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Flex,
  Form,
  FormInstance,
  InputNumber,
  message,
  Progress,
  Radio,
  Select,
  Typography,
  UploadFile,
  UploadProps
} from 'antd';
import { UploadListType } from 'antd/es/upload/interface';
import { useWatch } from "antd/lib/form/Form";
import { saveAs } from "file-saver";
import { get, isEmpty } from "lodash";
import { MouseEvent, ReactElement, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { PublishCoursePlaceEnum } from '../../../../../constants/course';
import {
  createCost,
  getAllOptionShare,
  getPaymentMethods,
  importExcelFileShare
} from "../../../../../service/content-course/contenCourseApi";
import { deleteAllShareCourse, getSampleTemplateExcel } from "../../../../../service/course-construct";
import { getUniversities } from "../../../../../service/university";
import { globalStore, useAuthStore } from "../../../../../stores/stores";
import { convertErrors } from "../../../../../utils/arrays";
import { FileType } from "../../../../../utils/uploadImage";
import CustomCard from "../../../../custom-card/CustomCard";
import FormItemDropdown from "../../../../form-dropdown/FormItemDropdown";
import { ExcelFileIcon } from "../../../../icons/svg";
import ModalUploadFileExcel from "../../../../modal/modal-upload-file-excel";
import NotificationSetting from '../../setting-content-course/notification-setting';
import SettingFee from "../../setting-content-course/setting-fee";
import SettingSchedule from "../../setting-content-course/setting-schedule";
import './index.scss';


type TabSettingPublishProps = {
  dataCostCourse?: any,
  dataConfig?: any,
  formWrapper?: FormInstance,
  isDirty: boolean,
  methodFeeValue: boolean,
  courseStatus: number,
  courseDetail: any,
  isRevoke: boolean,
  setDirty: (value: boolean) => void,
  setIsRevoke: (value: boolean) => void,
}


const TabSettingPublish = ({
  dataCostCourse,
  dataConfig,
  formWrapper,
  methodFeeValue,
  courseStatus,
  courseDetail,
  isRevoke,
  setDirty,
  setIsRevoke
}: TabSettingPublishProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { id } = useParams()
  const { reload, setReload } = globalStore()
  const costCourseValue = useWatch('costCourse', form)
  const costCreditValue = useWatch('costCredit', form)
  const costCertificationValue = useWatch('costCertification', form)
  const costValue = useWatch('isCostFree', form)
  const certificateSelectValue = useWatch('isHasCertification', form)
  const scheduleValue = useWatch('isScheduleByTeacher', form)
  const { accessToken } = useAuthStore()
  const [options, setOptions] = useState<any[]>([])
  const [optionsData, setOptionsData] = useState<any>({
    dataUsers: [],
    dataUniversity: []
  })
  const [newOptionsUsers, setNewOptionsUsers] = useState<any[]>([])
  const [newOptionsUniversity, setNewOptionsUniversity] = useState<any[]>([])
  const [isOpenedImport, setIsOpenedImport] = useState<boolean>(false)
  const [isHasUsers, setIsHasUsers] = useState<boolean>(true)
  const [isCheckFormPublish, setIsCheckFormPublish] = useState<boolean>(false)
  const [checkUploadFile, setCheckUploadFile] = useState<boolean>(false)
  const [isRevoking, setIsRevoking] = useState<number>(0);
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [fileList, setFileList] = useState<FileType[]>([]);
  const [checkboxValue, setCheckboxValue] = useState({
    value: {
      checkCost: false,
      checkCostCertification: false
    },
    disabled: {
      checkCost: false,
      checkCostCertification: false
    }
  })
  const [dataOptionsMethod, setDataOptionsMethod] = useState({
    paymentsMethod: []
  })
  const [initialValues, setInitialValues] = useState({})

  const fetchAllDataShare = async () => {
    const data = {
      page: 1,
      size: 100000000
    }
    try {
      const response = await Promise.allSettled([getAllOptionShare(data), getUniversities(data)])
      const newDataUsersOption = response[0].status === "fulfilled" ? response[0].value.data.data.content.filter((obj: {
        email: string;
        name: string,
        id: number
      }, index: any, self: any[]) => index === self.findIndex((o) => o.email === obj.email)).map((user: any) => {
        return {
          name: user.name,
          code: user.email
        }
      }) : []

      const newDataUniversityOption = response[1].status === "fulfilled" ? response[1].value.data.content.filter((obj: {
        uuid: any;
        name: string
      }, index: any, self: any[]) => index === self.findIndex((o) => o.uuid === obj.uuid)).map((university: any) => {
        return {
          name: university.name,
          code: university.uuid,
        }
      }) : []
      setOptionsData({
        ...optionsData,
        dataUsers: newDataUsersOption,
        dataUniversity: newDataUniversityOption
      })
    } catch (e) {
      console.error(e)
    }
  }

  const fetchOptionsPayment = async () => {
    try {
      const response = await getPaymentMethods()
      // @ts-ignore
      const { data } = response
      setDataOptionsMethod({
        ...dataOptionsMethod,
        paymentsMethod: data.data
      })

    } catch (err) {
      console.error(err)
    }
  }


  const beforeUploadFile = (file: FileType) => {
    setCheckUploadFile(true);
    const isExcel = file.type === "text/csv" || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'

    if (!isExcel) {
      message.error(t("Chỉ tải lên được file xlsx/csv", "Chỉ tải lên được file xlsx/csv"));
    }
    setFileList([file])
    return isExcel;
  };


  const handleUpload = async (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (event: { loaded: number; total: number; }) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        onProgress({ percent: (event.loaded / event.total) * 100 });
      }
    };
    fmData.append('file', file);
    fmData.append('isEnterprise', isHasUsers ? 'true' : 'false');
    fmData.append('courseId', Number(id).toString());

    try {
      setErrorMessage(null)
      const response = await importExcelFileShare(fmData, config);
      onSuccess(response);
      if (response && response.status === 200 && !isHasUsers) {
        const newOptions = optionsData.dataUsers.filter((user: {
          code: any;
        }) => response.data.data.includes(user.code)).map((user: { code: any; }) => user.code)
        setNewOptionsUsers(newOptions)
      }
      if (response && response.status === 200 && isHasUsers) {
        const newOptions = optionsData.dataUniversity.filter((university: {
          code: any;
        }) => response.data.data.includes(university.code)).map((university: { code: any; }) => university.code)
        setNewOptionsUniversity(newOptions)
      }

    } catch (error: any) {
      if (error.response.data.codeStatus === 400) {
        setCheckUploadFile(true)
        message.error(`Tệp ${file.name} tải lên thất bại.`);
        setErrorMessage(error.response.data.message)
      }
      console.error(error);
      onError(error);
    }
  }


  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    multiple: false,
    customRequest: handleUpload,
    beforeUpload: beforeUploadFile,
    fileList: fileList,
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        setCheckUploadFile(true)
      }

      if (status === 'done') {
        message.success(`Tệp ${info.file.name} tải lên thành công.`);

        setCheckUploadFile(false)
      }
    },
    onDrop(e) {
    },
    iconRender: (file: UploadFile<any>, listType?: UploadListType | undefined) => {
      const isExcel = file.type === "text/csv" || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      return (
        (<FileExcelOutlined style={{ color: `${isExcel ? '#52C41A' : '#FF4D4F'}` }} />)
      )
    },
    itemRender: (originNode: ReactElement, file: UploadFile, fileList,
      actions: { download: any, preview: any, remove: any }
    ) => {
      const isExcel = file.type === "text/csv" || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'

      const errorMessages = errorMessage && convertErrors(errorMessage)
      return (
        <>
          {
            <>
              <Flex justify={'space-between'} className="item-render">
                <p className="status-progress--upload">
                  <span>
                    <ExcelFileIcon />
                  </span>
                  <span>
                    {file.name}
                  </span></p>
                <Progress percent={progress}
                  status={checkUploadFile ? 'exception' : 'success'}
                  showInfo={true}
                  size={'default'}
                  style={{ width: 200 }} />
              </Flex>
              {
                !isExcel ? (
                  <div className="errorUpload">
                    <span>{t("Lỗi định dạng file!", "Lỗi định dạng file!")}</span>
                  </div>
                ) : isExcel && errorMessage ? (
                  <div className="errorUpload">
                    <Flex vertical={true} gap={"small"}>
                      <span>
                        {t("Lỗi dữ liệu file!", "Lỗi dữ liệu file!")}
                      </span>
                      {errorMessages && errorMessages.map((mess: string, index: number) => (
                        <span key={index}>
                          {mess}
                        </span>
                      ))}
                    </Flex>
                  </div>
                ) : (
                  <></>
                )
              }
            </>
          }
        </>
      )
    }
  };


  const createPublish = async (value: any) => {
    try {
      const response = await createCost(value)
      if (response.data) {
        message.success(t("Cài đặt thành công", "Cài đặt thành công"))
        setTimeout(() => {
          setReload(!reload)

        }, 400)

      }
    } catch (err) {
      if (!value.isScheduleByTeacher && !value.limit && !value.typeLimit) {
        message.error(t("Vui lòng thiết lập nỗ lực mong chờ", "Vui lòng thiết lập nỗ lực mong chờ"))
      }
      console.error(err)
    }
  }
  const fillData = () => {
    form.setFieldsValue({
      users: dataCostCourse.shareUsers,
      university: dataCostCourse.shareEnterprise,
      courseFormatId: dataCostCourse.formatId,
      displayPlace: dataCostCourse.displayPlace,
      costCourse: dataCostCourse.cost,
      costCredit: dataCostCourse.costCredit,
      costCertification: dataCostCourse.costCertification,
      isHasCertification: dataCostCourse.isHasCertification === 1,
      paymentMethodId: dataCostCourse.paymentMethod !== null ? dataCostCourse.paymentMethod : [1],
      isCostFree: dataConfig.isCostFree,
      typeLimit: !dataCostCourse.isScheduleByTeacher ? dataCostCourse.typeLimit : 1,
      limit: !dataCostCourse.isScheduleByTeacher ? dataCostCourse.limit : null,
      isScheduleByTeacher: dataCostCourse.isScheduleByTeacher,
      receivedOverMail: dataCostCourse.receivedOverMail !== null ? get(
        dataCostCourse,
        "receivedOverMail", true
      ) : true,
      receivedOverSystem: get(
        dataCostCourse,
        "receivedOverSystem"
      ),
      isDefault: dataCostCourse.notificationIsDefault !== null ? get(dataCostCourse, 'notificationIsDefault', true) : true,
      notificationOptional: !dataCostCourse.notificationIsDefault ? get(
        dataCostCourse,
        "notificationOptionals",
        [1]
      ) : []
    })
  }


  const dataOptions = [
    {
      label: t("Trên trang của trường", "Trên trang của trường"),
      value: PublishCoursePlaceEnum.UNIVERSITY
    },
    {
      label: t("Trên trang chung của bộ", "Trên trang chung của bộ"),
      value: PublishCoursePlaceEnum.MINISTRY
    }
  ]

  useEffect(() => {
    fetchOptionsPayment()
    fetchAllDataShare()
  }, []);


  useEffect(() => {
    if (dataCostCourse?.id) {
      fillData()
    } else {
      setInitialValues({
        courseFormatId: 3,
        displayPlace: PublishCoursePlaceEnum.MINISTRY,
        isScheduleByTeacher: false,
        isHasCertification: 0,
        isCostFree: true,
        isDefault: true,
        paymentMethodId: [1],
        receivedOverMail: true
      })
      form.setFieldsValue({
        courseFormatId: 3,
        isScheduleByTeacher: false,
        isHasCertification: 0,
        isCostFree: true
      })
    }
  }, [dataCostCourse]);

  useEffect(() => {
    if (costValue) {
      form.setFieldValue('costCourse', null)
    }
  }, [costValue]);


  useEffect(() => {
    if ((dataCostCourse && dataCostCourse.isCostFree && dataCostCourse.isHasCertification === 0)) {
      setCheckboxValue({
        ...checkboxValue,
        value: {

          checkCost: false,
          checkCostCertification: false

        },
        disabled: {
          checkCost: false,
          checkCostCertification: false
        }
      })

    } else if (dataCostCourse.isHasCertification === 1 && !dataCostCourse.isCostFree) {
      setCheckboxValue({
        ...checkboxValue,
        value: {

          checkCost: true,
          checkCostCertification: true

        },
        disabled: {
          checkCost: true,
          checkCostCertification: true
        }
      })
    } else if (dataCostCourse.isHasCertification === 1 && dataCostCourse.isCostFree) {
      setCheckboxValue({
        ...checkboxValue,
        value: {

          checkCost: false,
          checkCostCertification: true

        },
        disabled: {
          checkCost: false,
          checkCostCertification: true
        }
      })
    } else if (dataCostCourse.isHasCertification === 0 && !dataCostCourse.isCostFree) {
      setCheckboxValue({
        ...checkboxValue,
        value: {

          checkCost: true,
          checkCostCertification: false

        },
        disabled: {
          checkCost: true,
          checkCostCertification: false
        }
      })
    }
    if ((dataCostCourse && dataCostCourse.isScheduleByTeacher)) {
      setIsCheckFormPublish(true)
    } else {
      setIsCheckFormPublish(false)
    }
  }, [dataCostCourse]);

  useEffect(() => {
    if (scheduleValue) {
      form.setFieldsValue({
        courseFormatId: 2
      })
      setIsCheckFormPublish(true)
    } else {
      setIsCheckFormPublish(false)
    }
  }, [scheduleValue])


  useEffect(() => {
    if (dataOptionsMethod.paymentsMethod.length > 0) {
      const newData = dataOptionsMethod.paymentsMethod.map((item: any) => {
        return {
          label: item.name,
          value: item.id
        }
      })
      setOptions(newData)
    }
  }, [dataOptionsMethod.paymentsMethod]);


  useEffect(() => {
    const costCourse = Number(costCourseValue) || 0;
    const costCertification = Number(costCertificationValue) || 0;

    if (costCourse || costCertification) {
      form.setFieldsValue({
        totalFee: costCourse + costCertification,
      });
    } else {
      form.setFieldsValue({
        totalFee: 0,
      });
    }
  }, [costCourseValue, costCreditValue, costCertificationValue]);


  const handleInputChange = (value: any, name: string) => {
    const isChecked = value > 0;
    setCheckboxValue({
      ...checkboxValue,
      [name]: isChecked,
    });
  };

  // Get share data user, university
  const dataChange = useWatch('users', form);
  const dataCostCourseUser = dataCostCourse?.shareUsers;
  const dataChangeUniversity = useWatch('university', form);
  const dataCostCourseUniversity = dataCostCourse?.shareEnterprise;

  // List deleted user, university
  const dataUsersFilter = dataCostCourseUser?.filter((course: any) => !dataChange?.includes(course));
  const dataUniversityFilter = dataCostCourseUniversity?.filter((university: any) => !dataChangeUniversity?.includes(university));

  const onFinish = (value: any) => {
    setDirty(false)
    const dataReq = {
      idCourse: Number(id),
      courseFormatId: value.courseFormatId,
      displayPlace: Number(value.displayPlace),
      costCourse: value.costCourse != null ? value.costCourse : 0,
      costCredit: value.costCredit != null ? value.costCredit : 0,
      costCertification: value.costCertification != null ? value.costCertification : 0,
      paymentMethodId: value.paymentMethodId != null ? value.paymentMethodId : [],
      isScheduleByTeacher: value.isScheduleByTeacher,
      isCostFree: value.isCostFree,
      isHasCertification: value.isHasCertification,
      limit: !value.isScheduleByTeacher ? value.scheduleCourse.limit : null,
      typeLimit: !value.isScheduleByTeacher ? value.scheduleCourse.typeLimit : 1,
      notificationConfigId: get(dataConfig, "notificationConfigId", 0),
      notificationConfig: {
        isDefault: value.isDefault,
        isDeleted: value.isDeleted,
        receivedOverMail: value.receivedOverMail !== null ? value.receivedOverMail : false,
        receivedOverSystem: value.receivedOverSystem !== null ? value.receivedOverSystem : false,
        notificationOptionalId: value.notificationOptional,
      },
      uuids: !isEmpty(value.university) ? value.university : [],
      userEmails: !isEmpty(value.users) ? value.users : [],
      userDeleteEmails: !isEmpty(dataUsersFilter) ? dataUsersFilter : [],
      deleteUuids: !isEmpty(dataUniversityFilter) ? dataUniversityFilter : [],
    }
    createPublish(dataReq)
  }

  const handleValuesChange = () => {
    setDirty(true)
  }

  const resetForm = () => {
    fillData()
  }

  const handleCancel = () => {
    setIsOpenedImport(false)
    setErrorMessage(null)
    setFileList([])
  }

  const handleOK = () => {
    setIsOpenedImport(false)
    if (!isHasUsers && newOptionsUsers.length > 0) {
      form.setFieldsValue({
        users: newOptionsUsers
      })
    }
    if (isHasUsers && newOptionsUniversity.length > 0) {
      form.setFieldsValue({
        university: newOptionsUniversity
      })
    }
    setFileList([])
    setErrorMessage(null)
    message.success(t("Cập nhật danh sách thành công", "Cập nhật danh sách thành công"))

  }

  const downloadSample = async (e: MouseEvent) => {
    e.preventDefault()
    try {
      const response = await getSampleTemplateExcel(isHasUsers, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'blob' },
      })
      if (response.data) {
        const outputFilename = `sampleTemplate.xlsx`;
        let blobFile = new Blob([response.data], { type: 'application/json' });

        saveAs(blobFile, outputFilename)
      }
    } catch (err) {
      console.error(err);
    }

  }

  const handleOpenImport = (check: boolean, status: boolean) => {
    setIsOpenedImport(check)
    setIsHasUsers(status)
  }

  // 1: user loading
  // 2: university loading
  const handleRevoke = async (isEnterprise: boolean) => {
    if (!isEnterprise) {
      setIsRevoking(1);
    } else {
      setIsRevoking(2);
    }
    const dataReq = {
      courseId: courseDetail.id,
      isEnterprise: isEnterprise,
    }
    try {
      await deleteAllShareCourse(dataReq).then((res) => {
        if (res.status === 200) {
          setIsRevoke(!isRevoke);
          message.success(`Thu hổi ${isEnterprise ? 'trường' : 'người dùng'} thành công!`);
          setTimeout(() => {
            setIsRevoking(0);
          }, 333);
        }
      })
    } catch (err) {
      setIsRevoking(0);
      message.success(t("Có lỗi, vui lòng thử lại!", "Có lỗi, vui lòng thử lại!"));
      console.error(err);
    }
  }

  useEffect(() => {
    if (costValue === true) {
      form.setFieldsValue({ paymentMethodId: [] });
    }
    else {
      form.setFieldsValue({
        paymentMethodId: dataCostCourse?.paymentMethod,
        costCourse: dataCostCourse?.cost

      });

    }
  }, [costValue]);

  return (
    <>
      <div className="publish-settings">
        <section className="setting-course">
          <div className="form-settings">
            <Form form={form} onFinish={onFinish}
              initialValues={initialValues}
              onValuesChange={handleValuesChange}>
              {
                (courseStatus === 12 || courseStatus === 13)
                  ?
                  <CustomCard title={t("Chia sẻ", "Chia sẻ")} className="wrapper-settings--card">
                    <div className="info-publish-wrapper select-display">
                      <div className="title">
                        {t("Người dùng:", "Người dùng:")}
                      </div>
                      <div className="form-item--info_publish">
                        <Form.Item name="users">
                          <FormItemDropdown modeDropdown="multiple" options={optionsData.dataUsers}
                            placeholder={t("Chọn người dùng", "Chọn người dùng")} />
                        </Form.Item>
                      </div>
                      <div className="form-item--info_import">
                        <Button onClick={() => handleOpenImport(true, false)}><PlusOutlined />
                          Import
                        </Button>
                      </div>
                      <div className="form-item--revoke">
                        <Button style={{ backgroundColor: '#FF9500', color: '#fff', minWidth: 78 }}
                          onClick={() => handleRevoke(false)} disabled={(isRevoking === 1)}>
                          {isRevoking === 1 ? <LoadingOutlined /> : 'Thu hồi'}
                        </Button>
                      </div>
                    </div>
                    <div className="info-publish-wrapper select-display">
                      <div className="title">
                        {t("Trường:", "Trường:")}
                      </div>
                      <div className="form-item--info_publish">
                        <Form.Item name="university">
                          <FormItemDropdown modeDropdown="multiple" options={optionsData.dataUniversity}
                            placeholder={t("Chọn trường", "Chọn trường")} />
                        </Form.Item>
                      </div>
                      <div className="form-item--info_import">
                        <Button onClick={() => handleOpenImport(true, true)}><PlusOutlined />
                          Import
                        </Button>
                      </div>
                      <div className="form-item--revoke">
                        <Button style={{ backgroundColor: '#FF9500', color: '#fff', minWidth: 78 }}
                          onClick={() => handleRevoke(true)} disabled={(isRevoking === 2)}>
                          {isRevoking === 2 ? <LoadingOutlined /> : 'Thu hồi'}
                        </Button>
                      </div>
                    </div>
                  </CustomCard>
                  :
                  <></>
              }

              <SettingSchedule
                dataConfig={dataCostCourse}
                formInstanceWrapper={form}
              />
              {/* <Certificate setCheckboxValue={setCheckboxValue}/> */}
              <SettingFee formInstance={form} setCheckboxValue={setCheckboxValue}
                dataConfig={dataCostCourse} />
              <CustomCard title={t("Trả phí", "Trả phí")} className="wrapper-settings--card setting-cost">
                <div className="form-item--fee">
                  <label className="form-item--fee_title">
                    {t("Giá khóa học:", "Giá khóa học:")}
                  </label>
                  <Checkbox checked={checkboxValue.value.checkCost}
                    disabled={!checkboxValue.disabled.checkCost}
                    onChange={(e) => {
                      setCheckboxValue({
                        ...checkboxValue,
                        value: { ...checkboxValue.value, checkCost: e.target.checked }
                      })
                      if (checkboxValue.value.checkCost) {
                        form.setFieldValue('costCourse', null)
                      }
                    }} />
                  <Form.Item
                    name="costCourse"
                    rules={[
                      {
                        validator: async (_, value) => {
                          const isPaid = form.getFieldValue('isCostFree') === false;
                          if (isPaid && (value === null || value === undefined || value === '')) {
                            return Promise.reject(new Error("Vui lòng nhập giá khóa học."));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      addonAfter="VND"
                      className="form-input"
                      min={"0"}
                      controls={false}
                      onChange={(value) => handleInputChange(value, 'checkCost')}
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      disabled={!checkboxValue.disabled.checkCost}
                      parser={(value?: string) => value ? value.replace(/\$\s?|(,*)/g, '') : ""}
                      onKeyDown={(e) => {
                        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                        if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>

                </div>
                <div className="form-item--fee">
                  <label className="form-item--fee_title">
                    {t("Giá chứng chỉ:", "Giá chứng chỉ:")}
                  </label>
                  <Checkbox checked={checkboxValue.value.checkCostCertification || costCertificationValue}
                    onChange={(e) => {
                      setCheckboxValue({
                        ...checkboxValue,
                        value: {
                          ...checkboxValue.value,
                          checkCostCertification: e.target.checked
                        }
                      })
                      if (checkboxValue.value.checkCostCertification) {
                        form.setFieldValue('costCertification', null)
                      }
                    }}
                  />
                  <Form.Item name="costCertification">
                    <InputNumber addonAfter="VND" className="form-input"
                      min={"0"}
                      controls={false}
                      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      onChange={(value) => handleInputChange(value, 'checkCostCertification')}
                      parser={(value?: string) => value ? value.replace(/\$\s?|(,*)/g, '') : ""}
                      onKeyDown={(e) => {
                        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                        if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="form-item--fee total-fee">
                  <label className="form-item--fee_title">
                    {t("Tổng chi phí:", "Tổng chi phí:")}
                  </label>
                  <Form.Item name="totalFee">
                    <InputNumber addonAfter="VND" className="form-input"
                      disabled={true}
                      min={"0"}
                      controls={false}
                      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={(value?: string) => value ? value.replace(/\$\s?|(,*)/g, '') : ""} />
                  </Form.Item>
                </div>
              </CustomCard>
              <CustomCard title={t("Thông tin xuất bản", "Thông tin xuất bản")} className="wrapper-settings--card">
                <div className="info-publish-wrapper">
                  <div className="title">
                    {t("Hình thức xuất bản:", "Hình thức xuất bản:")}
                  </div>
                  <div className="form-item--info_publish">
                    <Form.Item name="courseFormatId">
                      <Radio.Group className="options-notification--type">
                        <div className="wrapper-radio">
                          <Radio value={1} disabled={isCheckFormPublish}>
                            {t("Thẻ ghi danh", "Thẻ ghi danh")}
                          </Radio>
                          <div className="message">
                            <Typography.Text className="sub-title">
                              Khóa học được xây dựng lộ trình trong quá trình giảng dạy tùy theo chất lượng học viên
                              đăng
                              ký. Người dùng có thể thực hiện tự ghi danh sau khi khóa học mở chức năng ghi danh hoặc
                              được
                              ghi danh bởi QTKH hoặc Giảng viên phụ trách
                            </Typography.Text>
                          </div>
                        </div>
                        <div className="wrapper-radio">
                          <Radio value={2}>
                            {t("Riêng tư", "Riêng tư")}
                          </Radio>
                          <div className="message">
                            <Typography.Text className="sub-title">Khóa học xuất bản ở chế độ không công khai, chỉ hiển
                              thị
                              với người dùng được ghi danh bởi QTKH hoặc Giảng viên phụ trách
                            </Typography.Text>
                          </div>
                        </div>
                        <div className="wrapper-radio">
                          <Radio value={3} disabled={isCheckFormPublish}>
                            {t("Tự do", "Tự do")}
                          </Radio>
                          <div className="message">
                            <Typography.Text className="sub-title">Khóa học xuất bản ở chế độ công khai, mọi người dùng
                              đều
                              có
                              thể thực hiện ghi danh sau khi khóa học mở ghi danh
                            </Typography.Text>
                          </div>
                        </div>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
                <div className="info-publish-wrapper select-display">
                  <div className="title">
                    {t("Nơi hiển thị:", "Nơi hiển thị:")}
                  </div>
                  <div className="form-item--info_publish ">
                    <Form.Item name="displayPlace" initialValue={PublishCoursePlaceEnum.MINISTRY}>
                      <Select options={dataOptions} placeholder={t("Chọn nơi hiển thị", "Chọn nơi hiển thị")} />
                    </Form.Item>
                  </div>
                </div>
              </CustomCard>
              <CustomCard title={t("Hình thức thanh toán", "Hình thức thanh toán")} className="wrapper-settings--card modal-setting--fee">
                <Form.Item
                  name="paymentMethodId"
                  className="form-item--payment"
                  rules={[
                    {
                      validator: async (_, value) => {
                        const isPaidCourse = form.getFieldValue('isCostFree') === false;
                        if (isPaidCourse && (!value || value.length === 0)) {
                          return Promise.reject(new Error("Vui lòng chọn hình thức thanh toán khi khóa học có trả phí."));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox.Group>
                    {options.map((option) => (
                      <Checkbox key={option.value} value={option.value} disabled={costValue}>
                        {option.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
              </CustomCard>
              <NotificationSetting form={form} />
              <div className="save-fee--info">
                <div className="group-button">
                  <Button
                    className="ant-btn-primary"
                    htmlType="submit"
                  >
                    <SaveOutlined />
                    <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
                  </Button>
                  <Button className="cancel-btn" onClick={resetForm}>
                    <CloseOutlined />
                    <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
          <ModalUploadFileExcel
            title={`Import danh sách ${!isHasUsers ? 'người dùng' : 'trường'}`}
            open={isOpenedImport}
            isHasUsers={!isHasUsers}
            isHasStudent={false}
            checkError={checkUploadFile}
            onOk={handleOK}
            onCancel={handleCancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            propsDragger={props}
            downloadSample={downloadSample}
          />
        </section>

      </div>
    </>
  );
};

export default TabSettingPublish;
